import * as React from 'react';
export const IcWatermelon = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20 6.84a9.74 9.74 0 00-2.89-3.45A2 2 0 0015.9 3a2 2 0 00-1.19.39l1.95 1.95A8 8 0 115.34 16.65L3.39 14.7A2 2 0 003 15.89a2 2 0 00.39 1.19A9.78 9.78 0 0021 11.21a9.58 9.58 0 00-1-4.37zM8.72 16.55A6.16 6.16 0 0011 17a6 6 0 005.54-3.7 6.06 6.06 0 00.34-3.47 6 6 0 00-1.64-3.07l-2-2-8.45 8.5 2 2a6.11 6.11 0 001.93 1.29zm3.57-8.27A1.05 1.05 0 0113 8a1 1 0 01.56.17 1 1 0 01.36.45 1 1 0 01.06.58 1 1 0 01-.78.78 1 1 0 01-.58-.05A1 1 0 0112 9a1.05 1.05 0 01.29-.72zm0 4A1.05 1.05 0 0113 12a1 1 0 01.56.17 1 1 0 01.36.45 1 1 0 01.06.58 1 1 0 01-.78.78 1 1 0 01-.58-.06 1 1 0 01-.45-.36A1 1 0 0112 13a1.05 1.05 0 01.29-.72zm-4 0A1.05 1.05 0 019 12a1 1 0 01.56.17c.162.113.29.269.37.45a1 1 0 01.05.58 1 1 0 01-.78.8 1 1 0 01-.58-.06 1 1 0 01-.45-.36A1 1 0 018 13a1.05 1.05 0 01.29-.72z'
      fill='currentColor'
    />
  </svg>
);
